import { Input } from 'components/Input'
import { Select } from '../../../../../components/Select'
import { useRebateConditionsFormContext } from '../Providers/RebateConditionsFormProvider'
import {
  isEmptyValue,
  minRebateValueValidator,
  percentageRebateValidator
} from 'features/ContractDetails/RebateConditions/RebateConditionsForm/utils'
import { PROPS_INPUT_NUMBER } from 'features/ContractDetails/RebateConditions/RebateConditionsForm/constants'
import { LABELS, PLACEHOLDERS } from 'constants/txt'
import { GrowthRebateProps } from './types'
import { RowLayout } from 'features/MyCommunity/Vendors/VendorCreation/General/VendorForm/RowLayout'
import { Separator } from 'components/Separator/Separator'

const GrowthRebateCondition = ({ handleChangeForm }: GrowthRebateProps) => {
  const { thresholdPeriodOptions, isAmountProvided, isBaselineSpendProvided } =
    useRebateConditionsFormContext()

  return (
    <>
      <Separator />
      <RowLayout title="Rebate conditions">
        <div className="column gap-16">
          <div className="row gap-12">
            <Input.Number
              propsItem={{
                name: 'purchase_volume_threshold',
                label: LABELS.BASELINE_SPEND,
                dependencies: ['amount'],
                rules: [
                  {
                    validator: (_, value) => {
                      if (isEmptyValue(value)) {
                        return isAmountProvided
                          ? Promise.reject(
                              new Error(
                                'Baseline spend is required when rebate amount is set'
                              )
                            )
                          : Promise.resolve()
                      }
                      return minRebateValueValidator(_, value)
                    }
                  }
                ]
              }}
              propsInputNumber={PROPS_INPUT_NUMBER}
            />
            <Input.Number
              propsItem={{
                name: 'amount',
                dependencies: ['purchase_volume_threshold'],
                label: LABELS.REBATE_AMOUNT,
                rules: [
                  {
                    validator: (_, value) => {
                      if (isEmptyValue(value)) {
                        return isBaselineSpendProvided
                          ? Promise.reject(
                              new Error(
                                'Rebate amount is required when baseline spend is set'
                              )
                            )
                          : Promise.resolve()
                      }
                      return percentageRebateValidator(_, value)
                    }
                  }
                ]
              }}
              propsInputNumber={PROPS_INPUT_NUMBER}
            />
          </div>
          <Select
            options={thresholdPeriodOptions}
            propsItem={{
              name: 'period_threshold',
              label: LABELS.PERIOD_THRESHOLD
            }}
            propsSelect={{
              placeholder: PLACEHOLDERS.PLEASE_SELECT,
              onChange: handleChangeForm
            }}
          />
        </div>
      </RowLayout>
    </>
  )
}

export default GrowthRebateCondition
